const d=({spacing:t})=>({styleOverrides:{root:{width:"100%",padding:t(1.5,3)}}});export{d as default};
